import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { computed, inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RouteStateService {
  private readonly router = inject(Router);
  readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.router.url)
    ),
    { initialValue: this.router.url }
  );

  isInRoute(prefix: string) {
    return computed(() => this.currentUrl().startsWith(prefix));
  }
}
